// mui
import { BottomNavigation, BottomNavigationAction, Stack } from '@mui/material';

// components
import { Icon } from '@/components/atoms/Icon/Icon';

// types
import { LinkItem } from '@/pwa/molecules/NavDrawer/NavDrawer';
import { theme } from '@/theme/mui';

interface NavMobileProps {
  links: LinkItem[];
  activePath?: string;
}
/**
 * NavMobile component for mobile navigation.
 */
export const NavMobile = ({ links, activePath }: NavMobileProps) => {
  return (
    <Stack
      direction='column'
      spacing={0}
      sx={{
        width: '100%',
        maxWidth: '100%',
        minHeight: 0,
        backgroundColor: 'custom.limeGreen.200',
      }}
    >
      <BottomNavigation
        showLabels
        value={activePath ?? false}
        sx={{ paddingX: theme.spacing(2) }}
      >
        {links.map((link, index) => (
          <BottomNavigationAction
            sx={{ gap: 1, minWidth: '60px', maxWidth: 'none' }}
            key={index}
            label={link.label}
            value={link.to}
            icon={<Icon icon={link.icon} type='fas' />}
            onClick={link.onClick}
          />
        ))}
      </BottomNavigation>
    </Stack>
  );
};

NavMobile.displayName = 'NavMobile';
export default NavMobile;
